import { http } from "@/http/index.js"
import store from "@/store/index.js"

//登陆 
const loginApi = ({
	LoginName,
	Password
}) => {
	return http("api/Login/Login", {
		LoginName,
		Password
	}, "post", false, true)
}
//导航 MenusData
const naviData = () => {
	return http("api/InitTree/MenusData", null, "get")
}



//退出  toolManage/system/longinOut/saveRecord
const exit = async () => {
	let tabs = store.getters.getTabs
	let selectedTab = store.getters.getSelectedTab
	let currentChildPath = store.getters.getCurrentChildRouterPath
	let index = tabs.findIndex(f => f.text == "首页")
	if (index) {
		tabs.splice(index, 1)
	}
	return http("api/ExitSave/AddExitSave", {
		tabs,
		CurrentInfase: {
			currentChildPath: currentChildPath,
			selectedTab: selectedTab
		}
	}, "post").then(() => {

	})
}

//指定用户的tabs api/ExitSave/GetData
const getTabs = () => {
	return http("api/ExitSave/GetData", null, "get")
}

//检查权限 toolManage/system/permission/queryPathAuthority
const checkAuth = path => {
	return http("api/InitTree/Jurisdiction", {
		path
	}, "get")
}

//修改密码 
const updatePassword = data => {
	return http("api/MyUserInfoes/UpdPassword", data, "post")
}

//增加菜单
const addNav = (api, naviObj) => {
	return http(api, naviObj, "post")
}

//增加用户
const addUser = userName => {
	return http("api/MyUserInfoes/SaveUser",
		userName, "post")
}
//删除用户
const delUser = id => {
	return http("api/MyUserInfoes/DelUserInfoById", id, "post")
}

//修改用户名
const updateUsers = users => {

	return http("toolManage/system/user/updateSystemUser",
		users, "post")
}

//修改用户名
const UpdataExamine = data => {

	return http("api/UserInfoSearch/UpdataExamine", data, "post")
}

//修改user绑定role
const updateUserPower = users => {
	return http("api/UserRights/AddUserRights",
		users, "post")
}

//根据userId查询对应角色
const GetRoleList = id => {
	return http("api/UserRights/GetData", {
		id
	}, "get")
}

//增加权限对象
const addPowerObj = parms => {
	return http("api/PermissionObject/AddPermissionObject", parms, "post")
}
//删除权限对象
const delPower = ids => {
	return http("api/PermissionObject/DeletePermissionObject", { id: ids }, "post")
}
//修改权限对象
const upDataPower = users => {
	return http("api/PermissionObject/UpdatePermissionObject",
		users, "post")
}
//权限对象树列表
const getPowerList = id => {
	return http("api/InitTree/ObjectData", {
		id
	}, "get")
}
//角色查询邦定的菜单树id
const getMenuListId = id => {
	return http("api/PermissionObject/MPidData", {
		id
	}, "get")
}

//修改权限对象树 
const updatePowerTree = users => {
	return http("api/PermissionObject/AddMPidData",
		users, "post")
}


//查询部门编号   //单位查询
const addCompany = data => {
	return http("api/SaveCompany/SaveCompany", data, "post")
}
// 公司信息 delete infoCompany
const DelCompany = data => {
	return http("api/DelCompany/DelCompany", data, "post")
}

// 品牌信息 添加，修改
const BrandEdit = data => {
	return http("api/Brand/BrandEdit", data, "post")
}
// 品牌信息delete
const BrandDel = data => {
	return http("api/Brand/BrandDelById", data, "post")
}

// 产品类别信息
const BrandType = data => {
	return http("api/ProductCategory/ProductCategoryEdit", data, "post")
}
// 产品类别信息delete
const BrandTypeDel = data => {
	return http("api/ProductCategory/ProductCategoryDel", data, "post")
}

// 字典信息delete 
const dictionaryDel = data => {
	return http("api/DaDicInfoAll/ProcessRequestDelete", data, "post")
}
// 字典信息 添加，修改
const dictionaryEdit = data => {
	return http("api/DaDicInfoAll/ProcessRequestAdd", data, "post")
}


// 一、字典类别 添加，修改
const DadicInfoSearchsTypeAdd = data => {
	return http("api/DaDicInfoAll/DadicInfoSearchsTypeAdd", data, "post")
}
// 增加技术知识库
// 知识库delete 
const WechatRobotReplyDelete = data => {
	return http("api/ModelNoSearch/WechatRobotReplyDelete", data, "post")
}
// 字典信息 添加，修改
const WechatRobotReplyRenew = data => {
	return http("api/ModelNoSearch/WechatRobotReplyRenew", data, "post")
}

// 型号信息新增，修改 /ModelNoSearch/ModelNoAdd
const modelEdit = data => {
	return http("api/ModelNoSearch/ModelNoAdd", data, "post")
}
// 型号信息 delete
const modelDel = data => {
	return http("api/ModelNoSearch/ModelNosDelete", data, "post")
}


// 配件信息新增，修改
const partsInfoEdit = data => {
	return http("api/Fitting/FittingEdit", data, "post")
}
// 配件信息 delete 
const partsDelete = data => {
	return http("api/Fitting/FittingDelById", data, "post")
}

// 维修级别 新增、修改
const repairLevelEdit = data => {
	return http("api/LevelSearch/LevelSearchAdd", data, "post")
}
// 维修级别 delete
const repairLevelDel = data => {
	return http("api/LevelSearch/LevelSearchDelete", data, "post")
}

// 附件信息 新增、修改
const AttachEdit = data => {
	return http("api/AttachInfo/AttachInfoAdd", data, "post")
}
// 附件信息 delete
const AttachDel = data => {
	return http("api/AttachInfo/AttachInfoDelete", data, "post")
}

// 症状信息 新增、修改
const symptomEdit = data => {
	return http("api/ModelIll/ModelIllEditSave", data, "post")
}
// 症状信息 delete
const symptomDel = data => {
	return http("api/ModelIll/ModelIllDelById", data, "post")
}

// 公司联系人 新增、修改
const contactsEdit = data => {
	return http("api/CompanyContract/CompanyContractEdit", data, "post")
}
// 公司联系人 delete
const contactsDel = data => {
	return http("api/CompanyContract/DelCompanyContractById", data, "post")
}

//运送维修中心
const RepairCenter = () => {
	return http("api/CusRepairTransfer/RepairCenter", null, "get")
}
//运送维修中心 联系人 地址
const SearchCompanyById = (data) => {
	return http("api/CusRepairTransfer/SearchCompanyById", data, "get")
}

//维修申请
const CompanyInfoes = () => {
	return http("api/MyUserInfoes/CompanyInfoesData", null, "get")
}
//Sn 
const SNSearchBySn = (sn) => {
	return http("api/Standby/PreMachineListSearchBySN", sn, "get")
}
//	维修申请 delete
const RepairDelete = data => {
	return http("api/ApplyRepairCommit/ApplyRepairDelete", data, "post")
}
//	维修申请列表 save
const RepairAdd = data => {
	return http("api/ApplyRepairCommit/ApplyRepairAdd", data, "post")
}


const linkMan = (Company_Id) => {
	return http("api/Guarantee/CompanyContracts", Company_Id, "get")
}
//	运送到维修中心del
const CusRepairTransferDel = data => {
	return http("api/CusRepairTransfer/CusRepairTransferCancelId", data, "post")
}
//	运送到维修中心提交
const CusRepairTransferCommit = data => {
	return http("api/CusRepairTransfer/CusRepairTransferCommit", data, "post")
}
//	报修申请提交 
const CusRepairApplyEdits = data => {
	return http("api/ApplyRepAirCommit/ApplyEdits", data, "post")
}
// 
//	维修登记列表
const RepairAddList = data => {
	return http("api/ApplyRepairCommit/RepairAdd", data, "post")
}
//	维修登记列表 DEL
const RepairDeleteList = data => {
	return http("api/ApplyRepairCommit/RepairDelete", data, "post")
}
// 维修设备接收删除api
const ChangeRepairDelete = data => {

	return http("api/SerApplyRepairCommit/ChangeRepairDelete", data, "post")
}

//	维修登记列表 提交
const SerApplyRepairCommits = data => {
	return http("api/SerApplyRepairCommit/SerApplyRepairCommits", data, "post")
}
//	维修检测列表 del
const ChangeRepairDetailStateById = data => {
	return http("api/SerApplyRepairCommit/ChangeRepairDetailStateById", data, "post")
}

//	维修检测列表 保存
const RepairDetectEditChangeState = data => {
	return http("api/SerApplyRepairCommit/RepairDetectEditChangeState", data, "post")
}

const RepairDetectEditBack = data => {
	return http("api/SerApplyRepairCommit/RepairDetectEditBack", data, "post")
}

// 设备维修信息返回
const RepairProductCancel = data => {
	return http("api/SerApplyRepairCommit/RepairProductCancel", data, "post")
}

//、设备返回
const RepairTransferReturnCancel = data => {
	return http("api/SerApplyRepairCommit/RepairTransferReturnCancel", data, "post")
}

//、设备返回快递信息提交
const CommitsRepair = data => {
	return http("api/SerApplyRepairCommit/RepairTransferReturnCommit", data, "post")
}
//、设备维修编辑报价信息
const MoneySave = data => {
	return http("api/SerApplyRepairCommit/MoneySave", data, "post")
}

//、维修完成确认
const ChangeRepairDetailStateByIds = data => {
	return http("api/SerApplyRepairCommit/ChangeRepairDetailStateByIds", data, "post")
}
//、设备维修编辑返厂维修
const BackFactorySave = data => {
	return http("api/SerApplyRepairCommit/BackFactorySave", data, "post")
}

//、设备维修编辑返厂维修 返厂状态
const AddRetRma = data => {
	return http("api/SerApplyRepairCommit/AddRetRma", data, "post")
}

//、设备维修
const RepairSave = data => {
	return http("api/SerApplyRepairCommit/RepairSave", data, "post")
}


//、合同信息删除
const ContractDelById = data => {
	return http("api/Contract/ContractDelById", data, "post")
}

// 合同信息添加  
const ContractEditds = data => {
	return http("api/Contract/ContractEditdx", data, "post")
}


const inserSubmit = data => {
	return http("api/Contract/ContractEditdx", data, "post")
}
// 添加sn列表
const SNEdit = data => {
	return http("api/Contract/SNEdit", data, "post")
}
// 删除sn列表
const SNDelById = data => {
	return http("api/Contract/SNDelById", data, "post")
}

// 巡检退回 sendBackApi
const sendBackApi = data => {
	return http("api/ServerPlantTask/ReturnBack", data, "post")
}
// 巡检任务添加
const ServerPlantTasksAdd = data => {
	return http("api/ServerPlantTask/ServerPlantTasksAdd", data, "post")
}
// 公司联系人查询
const CompanyContractSearch = data => {
	return http("api/Contract/CompanyContractSearch", data, "get")
}
// 服务类型查询
const ServerTypeSearch = data => {
	return http("api/ServerPlantTask/ServerTypeSearch", data, "get")
}
// 工程师查询
const RepairPlantUser = data => {
	return http("api/ServerPlantTask/RepairPlantUserName", data, "get")
}
// 巡检任务添加
const ServerPlantAdd = data => {
	return http("api/ServerPlantTask/ServerPlantTasksAdd", data, "post")
}
// 巡检任务删除
const ServerPlantTasksDel = data => {
	return http("api/ServerPlantTask/ServerPlantTasksDel", data, "post")
}
// 巡检任务完成
const ServerPlantTaskEditEditFinishById = data => {
	return http("api/ServerPlantTask/ServerPlantTaskEditEditFinishById", data, "post")
}
// 巡检任务编辑
const ServerPlantTasksEditSave = data => {
	return http("api/ServerPlantTask/ServerPlantTasksEditSave", data, "post")
}
// 巡检服务公司查询
const ShooinCompSearch = data => {
	return http("api/Contract/ShooinCompSearch", data, "get")
}
// 巡检任务结单
const ServerPlantTasksEditEmail = data => {
	return http("api/ServerPlantTask/ServerPlantTasksEdit", data, "post")
}
// 巡检记录删除
const ServerPlantTaskDel = data => {
	return http("api/ServerPlantTask/ServerPlantTaskDel", data, "post")
}
// 巡检要求信息删除 
const RequireDelete = data => {
	return http("api/Require/RequireDelete", data, "post")
}
// 巡检信息新增
const RequireAdd = data => {
	return http("api/Require/RequireAdd", data, "post")
}
// SN号删除
const ServerSNDelById = data => {
	return http("api/ServerPlantTask/SNDelById", data, "post")
}
// 服务申请记录删除
const ServerRepairDetailDel = data => {
	return http("api/ServerPlantTask/ServerRepairDetailDel", data, "post")
}
// 服务申请添加 
const ServerRepairDetailAdd = data => {
	return http("api/ServerPlantTask/ServerRepairDetailAdd", data, "post")
}

// 服务申请修改
const ServerRepairDetailEditSave = data => {
	return http("api/ServerPlantTask/ServerRepairDetailEditSave", data, "post")
}
// 编辑服务进度
const ServerRepairDetailEditAddSave = data => {
	let form = new FormData()
	let keys = Object.keys(data)
	keys.forEach(i => {
		form.append(i, data[i])
	})
	return http("api/ServerPlantTask/ServerRepairDetailEditAddSave", form, "post", false, false, true)
}
// 服务记录删除
const ServerRepairDetailDels = data => {
	return http("api/ServerPlantTask/ServerRepairDetailDels", data, "post")
}
// 服务记录结单
const ServerRepairDetailEdit = data => {
	return http("api/ServerPlantTask/ServerRepairDetailEdit", data, "post")
}
// 服务进度记录删除
const ServerRepairDetailEditEditDel = data => {
	return http("api/ServerPlantTask/ServerRepairDetailEditEditDel", data, "post")
}

// SN管理编辑
const ServerSNEdit = data => {
	return http("api/ServerPlantTask/SNEdit", data, "post")
}
// 设备接收
const RepairStateByState = data => {
	return http("api/SerApplyRepairCommit/ChangeRepairDetailState", data, "post")
}
// 货运公司
const TransComp = data => {
	return http("api/SerApplyRepairCommit/TransComp", data, "get")
}

// 设备清单删除 
const EquipmentsAdd = data => {
	return http("api/SerApplyRepairCommit/EquipmentsAdd", data, "post")
}

// 设备清单删除 EquipmentsDelete
const EquipmentsDelete = data => {
	return http("api/SerApplyRepairCommit/EquipmentsDelete", data, "post")
}

// 消息删除 
const infoDelete = data => {
	return http("api/ApplyRepairCommit/MesageNewById", data, "post")
}

//	修改申请列表信息
const ApplyDetailUpdate = data => {
	return http("api/ApplyRepairCommit/ApplyDetailUpdate", data, "post")
}
//	删除申请列表信息
const ApplyDetailDelete = data => {
	return http("api/ApplyRepairCommit/ApplyDetailDelete", data, "post")
}

export {
	ChangeRepairDelete,
	loginApi,
	naviData,
	exit,
	getTabs,
	updatePassword,
	checkAuth,
	delUser,
	updateUsers,
	UpdataExamine,
	addUser,
	addNav,
	addPowerObj,
	delPower,
	upDataPower,
	getPowerList,
	updatePowerTree,
	GetRoleList,
	updateUserPower,
	getMenuListId,
	addCompany,
	DelCompany,
	BrandEdit,
	BrandType,
	BrandDel,
	BrandTypeDel,
	WechatRobotReplyDelete,
	WechatRobotReplyRenew,
	dictionaryDel,
	dictionaryEdit,
	modelEdit,
	modelDel,
	partsInfoEdit,
	partsDelete,
	repairLevelEdit,
	repairLevelDel,
	AttachEdit,
	AttachDel,
	symptomEdit,
	symptomDel,
	contactsEdit,
	contactsDel,
	CompanyInfoes,
	RepairCenter,
	SearchCompanyById,
	linkMan,
	CusRepairTransferDel,
	CusRepairTransferCommit,
	ApplyDetailUpdate,
	ApplyDetailDelete,
	RepairDelete,
	RepairAdd,
	CusRepairApplyEdits,
	RepairAddList,
	RepairDeleteList,
	SerApplyRepairCommits,
	ChangeRepairDetailStateById,
	RepairDetectEditChangeState,
	RepairProductCancel,
	RepairTransferReturnCancel,
	CommitsRepair,
	MoneySave,
	ChangeRepairDetailStateByIds,
	BackFactorySave,
	RepairSave,
	ContractDelById,
	ContractEditds,
	inserSubmit,
	SNEdit,
	SNDelById,
	sendBackApi,
	ServerPlantTasksAdd,
	CompanyContractSearch,
	ServerTypeSearch,
	RepairPlantUser,
	ServerPlantAdd,
	ServerPlantTasksDel,
	ServerPlantTaskEditEditFinishById,
	ServerPlantTasksEditSave,
	ShooinCompSearch,
	ServerPlantTasksEditEmail,
	ServerPlantTaskDel,
	ServerSNDelById,
	ServerRepairDetailDel,
	ServerRepairDetailAdd,
	ServerRepairDetailEditSave,
	ServerRepairDetailEditAddSave,
	ServerRepairDetailDels,
	ServerRepairDetailEdit,
	ServerRepairDetailEditEditDel,
	ServerSNEdit,
	RepairStateByState,
	AddRetRma,
	RepairDetectEditBack,
	TransComp,
	DadicInfoSearchsTypeAdd,
	RequireDelete,
	RequireAdd,
	EquipmentsDelete,
	EquipmentsAdd,
	infoDelete,
	SNSearchBySn


}
